import moment from "moment";
import { ActionContext } from "vuex";
import { AccountStateInterface } from "./types";
import Account from "@/types/app/accounts";

moment.locale("en-US");
export default {  
  setModalNewAccountState(
    store: ActionContext<AccountStateInterface, any>,
    show: boolean
  ) {
    store.commit("setModalNewAccountState", show);
  },
  setModalCloneAccountState(
    store: ActionContext<AccountStateInterface, any>,
    show: boolean
  ) {
    store.commit("setModalCloneAccountState", show);
  },
  setModalAccountGroupingState(
    store: ActionContext<AccountStateInterface, any>,
    show: boolean
  ) {
    store.commit("setModalAccountGroupingState", show);
  },
  setModalAccountState(
    store: ActionContext<AccountStateInterface, any>,
    show: boolean
  ) {
    store.commit("setModalAccountState", show);
  },  
  setAccountState(
    store: ActionContext<AccountStateInterface, any>,
    account: Account
  ) {
    store.commit("setAccountState", account);
  },
  setAccountsState(
    store: ActionContext<AccountStateInterface, any>,
    accounts: Account[]
  ) {
    store.commit("setAccountsState", accounts);
  },
  seAccountSent(
    store: ActionContext<AccountStateInterface, any>,
    show: boolean
  ) {
    store.commit("setAccountSent", show);
  } 
  
};

